<template>
  <div>
    <v-card class="transparent elevation-0">
      <v-container container--fluid grid-list-md>
        <v-row>
          <v-col cols="12" :class="{'text-center': $vuetify.breakpoint.smAndDown}">
            <h1>Dispatch Group Allocations</h1>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field label="Search..." v-model="search" prepend-icon="search"></v-text-field>
          </v-col>

            <v-col cols="12" md="3">
              <v-dialog
                ref="dialogFrom"
                v-model="modalFrom"
                :return-value.sync="dateSelected"
                width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="dateSelected"
                    label="Select Date"
                    prepend-icon="event"
                    readonly
                    @click.native="modalFrom = true"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="dateSelected"
                  scrollable :max="today"
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="blue-grey lighten-2" @click="modalFrom = false">Cancel</v-btn>
                  <v-btn text color="blue darken-1" @click="$refs.dialogFrom.save(dateSelected)">OK</v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>


          <v-col cols="12" md="3">
            <v-select
              :items="renderedDepot"
              item-text="name"
              item-value="id"
              return-object
              v-model="depot"
              prepend-icon="fas fa-map"
              menu-props="auto"
              label="Select a Region"
              hide-details
              single-line
              auto-select-first
              :menu-props="{transition: 'slide-x-transition'}">
            </v-select>
          </v-col>
          <v-spacer></v-spacer>
        </v-row>
      </v-container>
      <v-divider></v-divider>
      <v-data-table
        :headers="headers"
        :items="renderedStaging"
        :search="search"
      >
        <template v-slot:item="props">
          <tr class="cursor" v-bind:class="{odd: props.index % 2, even: !props.index % 2}">
            <td v-if="header.text !== 'Actions'" style="text-align: center" v-for="(header, index) in headers" :key="index">
              {{props.item[header.value]}}
            </td>
            <td v-show="admin " style="text-align: center">
              <v-tooltip top color="secondary">
                <template v-slot:activator="{ on }">
                  <v-icon  color="blue" @click="rowSelected(props.item) " v-on="on">
                    send
                  </v-icon>
                </template>
                <span>Allocate</span>
              </v-tooltip>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>

    <AllocateRoute
      :staging_id="staging_id"
      :showDialog="dialog"
      v-on:close="closeDialog"
    ></AllocateRoute>

  </div>

</template>

<script>

import axios from 'axios';
import AllocateRoute from '../../util/AllocateRoute';

export default {
  name: "DispatchAllocation",
  components: {
     AllocateRoute
  },
  props: {
    default: function () {
      return {
        region: Object,
        regions: Array,
      }
    }
  },
  data() {
    return {
      valid: false,
      requiredRule: [
        v => !!v || 'This field is required.'
      ],
      reload: false,
      search: null,
      allSwitch: false,
      editedIndex: -1,
      editedItem: {
        name:null,
        type:null,
        region: 0,
        value:null,
      },
      apiSetting: {
        name:null,
        type:null,
        region: 0,
        value:null,
      },
      editDialog: false,
      displayedItem: null,
      region: null,
      headers:[
        {text: 'Staging Name', value: 'type', align: 'center', sortable: true},
        {text: 'Depot Name', value: 'delivery_depot_name', align: 'center', sortable: true},
        {text: 'Actions', value: 'actions', align: 'center', sortable: false,}
      ],
      types:[
        'emails',
        'string',
        'boolean',
        'integer',
      ],
      fault:[
        true,
        false,
      ],
      apiName:[],
      staging_id:null,
      dialog:false,
      dateSelected:null,
      modalFrom:null,
      today: new Date().toISOString().substr(0, 10),
      depot:null,
    }
  },
  methods: {
    rowSelected(item) {
      this.staging_id = item['id'];
      this.dialog = true;
    },
    closeDialog(){
      this.dialog = false;
    },
    updateDataTable() {
      this.reload = !this.reload;
    },

  },
  computed: {
    admin() {
      return this.$store.getters['auth/isAdmin'];
    },
    renderedStaging() {
      if (this.staging === null) return [];
      return this.staging;
    },
    regions: function () {
      let regions = this.$store.getters['auth/permissionRegions']('phone_view');
      if (this.$store.getters['auth/isAdmin']) {
        regions.push({"id": 0, "name": "Global"});
      }
      return regions;
    },
    renderedDepot() {
      if (this.depots === null) return [];
      this.depots =  this.depots.sort(function(a,b){
        if(a.region_name < b.region_name) return -1;
        if(a.region_name > b.region_name) return 1;
        return 0;
      });
      let gol = {
        "id": 0,
        "region_id": 0,
        "region_name": "Global",
        "name": "Global",
        "address": "",
        "address2": "",
        "suburb": "",
        "state": "NSW",
        "postcode": "",
        "code": "",
        "wms": false,
        "parent_depot": null,
        "active_phone_cap": "0"
      };
      this.depots.unshift(gol)
      // this.info = this.depot;
      return this.depots;
    },
  },
  mounted() {
    this.depot = this.regions[6];
  },
  asyncComputed: {
    async staging() {
      if (this.reload || !this.reload) {
        return await axios.get(process.env.API_URL + '/lastmiledispatch?' + 'depot_id=' + this.depot.id + '&date=' + this.dateSelected)
          .then((response) => {
            return response.data;
          })
          .catch((response) => {
            this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
            return [];
          });
      }
    },
    async depots() {
      return await axios.get(process.env.API_URL + '/depots')
        .then((response) => {
          return response.data;
        })
        .catch((response) => {
          this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
          return [];
        })
    },
  }



}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/Delivery/DispatchAllocation.vue